import { useCallback } from 'react'
import { useWallet } from '@tronweb3/tronwallet-adapter-react-hooks'
import { WalletReadyState } from '@tronweb3/tronwallet-abstract-adapter'
import type { Transaction, AdapterName } from '@tronweb3/tronwallet-abstract-adapter'

export function useTronWallet() {
  const { address, connected, connect, disconnect, wallet, signTransaction, signMessage, wallets, select } = useWallet()

  const tronReady = wallets?.some(w => w.adapter.readyState === WalletReadyState.Found) ?? false

  const connectTron = useCallback(async () => {
    await connect()
  }, [connect])

  const disconnectTron = useCallback(async () => {
    await disconnect()
  }, [disconnect])

  const signTronTransaction = useCallback(
    async (tx: Transaction) => {
      if (!signTransaction) {
        throw new Error('Tron wallet not connected or does not support signing')
      }
      return signTransaction(tx)
    },
    [signTransaction],
  )

  // Sign an arbitrary message (TIP-191 signMessageV2 under the hood for TronLink) — used to authorize
  // a cancel. Returns the signature string the backend verifies with tronWeb.trx.verifyMessageV2.
  const signTronMessage = useCallback(
    async (message: string): Promise<string> => {
      if (!signMessage) {
        throw new Error('Tron wallet not connected or does not support message signing')
      }
      return signMessage(message)
    },
    [signMessage],
  )


  return {
    tronAddress: address ?? null,
    tronConnected: connected,
    connectTron,
    disconnectTron,
    tronReady,
    signTronTransaction,
    signTronMessage,
    tronWallets: wallets ?? [],
    selectTronWallet: (name: string) => select(name as AdapterName),
    activeTronWallet: wallet,
  }
}
